import { IngestedEventSampleSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetLatestEventsResponseSchema = oz.object({
  events: oz.array(IngestedEventSampleSchema),
  countedFilteredEvents: oz.number().nonnegative(),
}).openapi('GetLatestEventsResponse');

export type GetLatestEventsResponse = oz.infer<typeof GetLatestEventsResponseSchema>;